// note: miscellaneous will not have any filter
export default {
  "allinone<<desktops": [
      "_6LN_"
   ],
   "small-form-factor<<desktops": [
     "8FVmj"
   ],
   "gaming<<desktops": [
     "9cAgK"
   ],
   "towers<<desktops": [
     "jBYtI"
   ],
   "thin-clients<<desktops": [
     "4mfuX"
   ],
   "workstations<<desktops": [
     "QRcff"
   ],
   "thin-clients<<laptops": [
     "-Fxpl"
   ],
   "notebooks<<laptops": [
     "V5x2z"
   ],
   "mobile-workstations<<laptops": [
     "Usq6y"
   ],
   "chargersadapters<<computer-hardware": [
     "ldaQi"
   ],
   "monitors<<computer-hardware": [
     "RgCAP"
   ],
   "input-devices<<computer-hardware":[
     "734xd"
   ],
   "cases-and-backpacks<<computer-accessories": [
     "pZsc9"
   ],
   "audio-devices<<computer-accessories": [
     "xcybO"
   ],
   "software<<computer-accessories": [
     "Z2Yyo"
   ],
   "3pp<<computer-accessories": [
     "b7J-b"
   ],
   "bundles<<computer-accessories": [
     "LT5e5"
   ],
   "cables<<computer-accessories": [
     "moQH_"
   ],
   "care-packswarranties<<computer-accessories": [
     "DNcRb"
   ],
   "calculators<<computer-accessories": [
     "gnZlL"
   ],
   "scanners<<printersscanners": [
     "fzYqt"
   ],
   "inkjets<<printersscanners": [
     "0KUfu"
   ],
   "laserjets<<printersscanners": [
     "AauN9"
   ],
   "paper<<printersscanners-accessories": [
     "gV1G6"
   ],
   "paper-feeders<<printersscanners-accessories": [
     "CKwcw"
   ],
   "maintenance-kits<<printersscanners-accessories": [
     "mmE_W"
   ],
   "print-servers<<printersscanners-accessories": [
     "nVtpk"
   ],
   "ink-cartridges<<printer-supplies": [
     "8tGLV"
   ],
   "toner-cartridges<<printer-supplies": [
     "3Nzv9"
   ],
   "convertibles<<laptops": [
     "KLl1N"
   ],
   "detachables<<laptops": [
     "xVHFL"
   ],
   "gaming<<laptops": [
     "67mwV"
   ],
    "hardware-components<<computer-hardware": [
      "KaxGu"
    ],
    "docking-stations<<computer-hardware": [
      "bxQvz"
    ]
  }
